import styled from 'styled-components'

import menuGlyph from 'iconoir/icons/menu.svg'

export const MenuIcon = styled(menuGlyph)`
  cursor: pointer;
`
